// The events that the machine handles
export enum VaultDepositEvent {
  UPDATE_ACCOUNT_INFO = 'UPDATE_ACCOUNT_INFO',
  INPUT_CHANGE = 'INPUT_CHANGE',
  LIQUIDITY_PERCENTAGE_CHANGE = 'LIQUIDITY_PERCENTAGE_CHANGE',
  CHECK_INPUT = 'CHECK_INPUT',
  DEPOSIT = 'DEPOSIT',
  APPROVE_TOKEN_ALLOWANCE = 'APPROVE_TOKEN_ALLOWANCE',
  RESET_TOKEN_ALLOWANCE = 'RESET_TOKEN_ALLOWANCE',
  LOAD_DATA = 'LOAD_DATA'
}
